import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../SliderStyles.css";

const About = () => {

  const images = [
    { src: "/img/AAEMT_Electro.png", alt: "AAEMT Electro" },
    { src: "/img/Trans_ACNR.png", alt: "Trans Acnr " },
    { src: "/img/Alstone.jpeg", alt: "Alstone" },
    { src: "/img/Emerge_Glass.png", alt: "Emerge Glass" },
    { src: "/img/Halonix.png", alt: "Halonix" },
    { src: "/img/Hitachi Astemo.gif", alt: "Hitachi Astemo" },
    { src: "/img/ILGIN.jpeg", alt: "ILGIN" },
    { src: "/img/LEDURE.png", alt: "LEDURE" },
    { src: "/img/LG Soft.png", alt: "LG Soft" },
    { src: "/img/Minda.png", alt: "Minda" },
    { src: "/img/Motherson_id7UdOkrBw_1.png", alt: "Motherson" },
    { src: "/img/Pavna-Industries-Logo.png", alt: "Pavna Industries" },
    { src: "/img/React Lab.jpg", alt: "React Lab" },
    { src: "/img/Regent Lighting.png", alt: "Regent Lighting" },
    { src: "/img/Rhode & Schwarz.png", alt: "Rhode & Schwarz" },
    { src: "/img/Sandhaar.png", alt: "Sandhaar" },
    { src: "/img/Sidwal.png", alt: "Sidwal" },
    { src: "/img/Signify_logo.png", alt: "Signify" },
    { src: "/img/Supreme_Car.jpg", alt: "Supreme Car" },
    { src: "/img/Tata_Motors_idhfHAmYXV_1.png", alt: "Tata Motors" },
    { src: "/img/Trans_ACNR.png", alt: "Trans ACNR" },
    { src: "/img/Valeo Motherson.png", alt: "Valeo Motherson" },
    { src: "/img/Volats.png", alt: "Volats" },
  ];
  // Custom arrow components
const PrevArrow = ({ onClick }) => (
  <button className="custom-arrow left-arrow" onClick={onClick}>
    &#9665;
  </button>
);

const NextArrow = ({ onClick }) => (
  <button className="custom-arrow right-arrow" onClick={onClick}>
    &#9655;
  </button>
);
  var settings = {
    dots: false, // Hide dots
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 1 } },
    ],
  };
  return (
    <div>
      <section class="inner-banner">
        <div class="thm-container">
          <h2>About Us</h2>
          <div class="breadcumb">
            <a href="/">Home</a>
            <i class="fa fa-angle-right"></i>
            <span>About Us</span>
          </div>
        </div>
      </section>
      <div class="full_wrapper padtb_100_100">
        <div class="container">
          <div class="row">
            <div class="col-lg-4 col-md-5 col-sm-12 col-xs-12">
              <span class="wdt_img img_100">
                <img
                  src="/img/WhatsApp Image 2025-01-09 at 14.03.30_61cee15c.jpg"
                  alt="About Img"
                  class="img-responsive my-2"
                />
                <div>
                  <img src="/img/WhatsApp Image 2025-01-12 at 09.09.39_2b14b7e1.jpg"></img>
                </div>
              </span>
            </div>
            <div class="col-lg-8 col-md-7 col-sm-12 col-xs-12 col_margin">
              <div class="plft50">
                <h3 class="mtopminus10 no_after letter_spac0 line_heg45 blue_head1">
                  We are giving best services to our clients since very{" "}
                  <span>long time</span>
                </h3>
                <p>
                  Technociv Technologies Pvt. Ltd. is a leading provider of
                  advanced automation and testing solutions, dedicated to
                  serving the automotive and electronics industries. Established
                  with a mission to deliver high-precision instruments and
                  sophisticated systems, we have rapidly evolved to meet the
                  diverse needs of our clients across various sectors. <br></br>Our
                  expertise lies in the development of automated solutions
                  tailored specifically for the automotive industry, focusing on
                  critical components such as DC-DC converters, battery
                  chargers, and motor controller units. We pride ourselves on
                  our proficiency in software development, particularly using NI
                  LabVIEW, which enables us to create precise and efficient
                  testing processes. This expertise allows us to implement
                  advanced automation techniques that significantly enhance the
                  reliability and performance of automotive components.<br></br> In
                  addition to our automotive solutions, we specialize in
                  providing comprehensive testing systems for the electronics
                  and electrical sectors. Our offerings include high-precision
                  test and measurement instruments designed for various
                  electronic applications, ensuring accuracy and compliance with
                  industry standards. We also focus on PCB testing and
                  validation, as well as custom ESD lab setups to protect
                  sensitive components during handling and testing.<br></br> At Technociv
                  Technologies, our commitment to quality and customer
                  satisfaction is unwavering. We ensure that all our solutions
                  comply with stringent industry standards, providing
                  comprehensive testing capabilities that guarantee the optimal
                  functioning and durability of essential systems. By choosing
                  us, clients can trust that they are receiving innovative and
                  effective test solutions tailored to their unique needs. Our
                  core values—innovation, quality, integrity, customer focus,
                  collaboration, sustainability, and excellence—guide our
                  operations and decision-making processes. They shape our
                  company culture and drive our mission to deliver exceptional
                  solutions that empower our clients to achieve operational
                  excellence. <br></br>With a strong emphasis on technological
                  advancement and a dedication to exceeding client expectations,
                  Technociv Technologies is poised to lead the way in automation
                  and testing solutions for the automotive and electronics
                  industries.
                </p>
                {/* <p class="fnt_18 mbot25">Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem
                  Ipsum has been the industry&#039;s standard dummy text ever since</p>
                <p class="mbot25">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque
                  laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae
                  vitae dicta sunt explicabo.</p>
                <p class="mbot45">Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia
                  consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui
                  dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia equi nesciunt.</p> */}
                <a
                  href="contactUs"
                  class="view-all hvr-bounce-to-right news_read_btn get_Quote"
                >
                  Get Quote
                </a>
                <a
                  href="news"
                  class="view-all hvr-bounce-to-right news_read_btn get_Quote view_service"
                >
                  View Solutions
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="full_width about_award_bg">
        <div class="container">
          <div class="row">
            {/* <!-- =========award-winning col start============--> */}
            <div class="col-lg-4 col-md-5 col-sm-12 col-xs-12 award_bg plft15">
              <img src="/img/WhatsApp Image 2024-09-22 at 16.56.05_a6bec35a.jpg" alt="Award Img" className="awardImg" />
            </div>
            {/* <!-- =========award-winning col end============--> */}
            {/* <!-- =========request-consultant col start============--> */}
            <div class="col-lg-8 col-md-7 col-sm-12 col-xs-12 fr">
              <div class="row award_pad">
                <div class="col-md-6  ">
                  <div class="row mbot70">
                    <div class="col-lg-3 col-md-4 col-sm-2 col-xs-2">
                      <img src="/img/award_icon-1.png" alt="award" />
                    </div>
                    <div class="col-lg-9 col-md-8 col-sm-10 col-xs-10">
                      <h4 class="letter_space_0 white_color">
                        Award Winning Engineering Solutions
                      </h4>
                      <p class="letter_spac0 lyt_color">
                      Delivering high-quality, precision-engineered solutions with innovation,
                       reliability,
                      and a commitment to excellence, 
                      recognized for our expertise in engineering and technology.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6  ">
                  <div class="row mbot70">
                    <div class="col-lg-3 col-md-4 col-sm-2 col-xs-2">
                      <img src="/img/engineer_icon.png" alt="award" />
                    </div>
                    <div class="col-lg-9 col-md-8 col-sm-10 col-xs-10">
                      <h4 class="letter_space_0 white_color">
                        Certified Engineers
                      </h4>
                      <p class="letter_spac0 lyt_color">
                      Our highly skilled, certified engineers provide innovative, precision-driven solutions, maintaining the highest industry standards.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row ">
                <div class="col-md-6  ">
                  <div class="row mbot70">
                    <div class="col-lg-3 col-md-4 col-sm-2 col-xs-2">
                      <img src="/img/modern_equip_icon.png" alt="award" />
                    </div>
                    <div class="col-lg-9 col-md-8 col-sm-10 col-xs-10">
                      <h4 class="letter_space_0 white_color">
                        Modern Equipment
                      </h4>
                      <p class="letter_spac0 lyt_color">
                      We utilize state-of-the-art equipment to enhance efficiency, accuracy, and quality across all production and service processes.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-md-6  ">
                  <div class="row mbot70">
                    <div class="col-lg-3 col-md-4 col-sm-2 col-xs-2">
                      <img src="/img/award_icon-1.png" alt="award" />
                    </div>
                    <div class="col-lg-9 col-md-8 col-sm-10 col-xs-10">
                      <h4 class="letter_space_0 white_color">
                        Advanced Technology
                      </h4>
                      <p class="letter_spac0 lyt_color">
                      Our cutting-edge technology enables exceptional precision, efficiency, and reliability, driving excellence in every project.
                      </p>
                    </div>
                  </div>
                </div>
                </div>
            </div>
            {/* <!-- =========request-consultant col end============--> */}
          </div>
        </div>
      </div>
      <div
        class="full_wrapper speciality_bg padtb_95_100"
        style={{
          background: "url(/img/speciality_bg.jpg) no-repeat center top",
          backgroundSize: "cover",
        }}
      >
        <div class="container">
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12">
              <h3 class="fnt_24 mbot15 letter_spac0">Our Sepcility</h3>
              <h4 class="mbot25">
                Delivering excellence through tailored solutions, innovative practices, and a dedicated commitment to quality.
              </h4>
              {/* <p class="mbot25">
                eaque ipsa quae ab illo inventore veritatis et quasi architecto
                beatae vitae dicta sunt explicabo.
              </p> */}
              <p>
                We pride ourselves on providing customized solutions that meet each client's unique needs. Our team combines industry expertise with innovative practices, using cutting-edge technology to ensure precise, high-quality results. With a commitment to excellence in every detail, we go above and beyond to deliver a seamless experience and outstanding outcomes for our clients.
              </p>
            </div>
            <div class="col-lg-1 col-md-6 col-sm-12 col-xs-12"></div>
            <div class="col-lg-5 col-md-6 col-sm-12 col-xs-12">
              <ul class="special_no">
                <li>
                  <span class="number">100 +</span>
                  <span class="txt">Projects Completed</span>
                </li>
                <li>
                  <span class="number">250 +</span>
                  <span class="txt">Satisfied Customers</span>
                </li>
                <li>
                  <span class="number">50 +</span>
                  <span class="txt">Projects Running</span>
                </li>
                <li>
                  <span class="number">98% +</span>
                  <span class="txt">Client Retention</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="full_wrapper padtb_95_100 team-member-about-us">
        <div class="container">
          <h3 class="mbot40">Our Directors</h3>
          <div class="row">
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 mtopminus10">
              <p>
                <b>Sumit Sinha</b> and <b>Sweety Kalpa</b>, bring a dynamic blend of experience, technical expertise, and visionary leadership to your company. Here's a detailed explanation of their profiles:
              </p>
            </div>
            <div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 col_margin">
              <div
                id="our_worker"
                data-ride="carousel"
                class="carousel slide four_shows_one_move"
              >
                <div class="controls pull-right">
                  <a
                    href="#our_worker"
                    data-slide="prev"
                    class="left fa fa-angle-left next_prve_control"
                  ></a>
                  <a
                    href="#our_worker"
                    data-slide="next"
                    class="right fa fa-angle-right next_prve_control"
                  ></a>
                </div>
                <div class="row">
                  <div id="teamCarousel" class="carousel slide" data-ride="carousel">
                    <div class="carousel-inner">
                      {/* <!-- Team Member 1 --> */}
                      <div class="item active">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center">
                          <div class="dedicated-team-img-holder mbot15">
                            <div class="">
                              <img src="/img/WhatsApp_Image_2025-01-09_at_13.19.03_9bf55cb0-removebg-preview.png" alt="team1" />
                            </div>
                            <div class="overlay">
                              <div class="inner-holder">
                                <ul>
                                  <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                                  <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                                  <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
                                  <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          {/* <!-- Name and Designation --> */}
                          <span class="team_name full_width">SUMIT SINHA</span>
                          <span class="team_designation full_width">Director</span>
                          <span class="team_designation full_width">B.Tech, MBA (Project Management)</span>
                        </div>
                        {/* <!-- Overview Section --> */}
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                          <p>
                            <strong>Overview:</strong> Sumit Sinha brings a wealth of knowledge in engineering and project management. His leadership has been instrumental in spearheading cutting-edge projects like the LG Composite Tester for R&D labs.
                          </p>
                          <p>
                            <strong>Vision Statement:</strong> "To transform engineering challenges into reliable and impactful solutions through innovation and teamwork."
                          </p>
                        </div>
                      </div>

                      {/* <!-- Team Member 2 --> */}
                      <div class="item">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center">
                          <div class="dedicated-team-img-holder mbot15">
                            <div class="shadow_effect effect-apollo">
                              <img src="/img/WhatsApp Image 2025-01-09 at 13.15.14_858b3ef3.jpg" alt="team2" />
                            </div>
                            <div class="overlay">
                              <div class="inner-holder">
                                <ul>
                                  <li><a href="#"><i class="fa fa-facebook"></i></a></li>
                                  <li><a href="#"><i class="fa fa-twitter"></i></a></li>
                                  <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
                                  <li><a href="#"><i class="fa fa-google-plus"></i></a></li>
                                </ul>
                              </div>
                            </div>
                          </div>
                          {/* <!-- Name and Designation --> */}
                          <span class="team_name full_width">SWEETY KALPA</span>
                          <span class="team_designation full_width">Director</span>
                          <span class="team_designation full_width">B.Tech (Electronics and Communication Engineering)</span>
                        </div>
                        {/* <!-- Overview Section --> */}
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                          <p>
                            <strong>Overview:</strong> Sweety Kalpa combines technical expertise with a creative approach to problem-solving. Her background in Electronics and Communication Engineering has been pivotal in designing robust and efficient systems. She is passionate about pushing the boundaries of technology to deliver excellence.
                          </p>
                          <p>
                            <strong>Vision Statement:</strong> "To empower businesses with advanced, reliable, and cost-effective engineering solutions."
                          </p>
                        </div>
                      </div>
                      {/* <!-- leadership --> */}
                      <div class="item">
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 text-center">
                          <div class="dedicated-team-img-holder mbot15">
                            <div class="shadow_effect effect-apollo">
                              <img src="/img/WhatsApp Image 2025-01-09 at 13.15.16_cdd20f4c.jpg" alt="team2" />
                            </div>
                          </div>
                          {/* <!-- Name and Designation --> */}
                          <span class="team_name full_width">Leadership Philosophy</span>
                        </div>
                        {/* <!-- Overview Section --> */}
                        <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                          <p>
                            A short section highlighting the collective philosophy of the directors:
                            “With a commitment to innovation, quality, and sustainability, our directors lead a team dedicated to delivering engineering excellence that aligns with our clients’ needs.”
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* <!-- Carousel Controls --> */}
                    <a class="left carousel-control" href="#teamCarousel" data-slide="prev">
                      <span class="glyphicon glyphicon-chevron-left"></span>
                    </a>
                    <a class="right carousel-control" href="#teamCarousel" data-slide="next">
                      <span class="glyphicon glyphicon-chevron-right"></span>
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
      <section class="full_wrapper brand-section">
        <div class="container">
          <h3 class="mbot40">Our Clients</h3>
          <div className="slider-container">
          <Slider {...settings}>
              {images.map((img, index) => (
                <div key={index} className="slide">
                  <img src={img.src} className="client_img" alt={img.alt} />
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
